<template>
  <modal
    class="unVisibleModal"
    title="Tekrar Gösterme Yapılan Rezervasyonlar"
    :size="'xl'"
    @close="$emit('close')"
  >
    <template #content>
      <div class="result">
        <div
          class="kr-unv-toolbar"
          style="display:flex;flex-wrap:nowrap;align-items:center;justify-content:space-between;gap:12px;"
        >
          <label class="kr-selectall">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectAllClick"
            />
            <span>Tümünü Seç</span>
          </label>
          <Btn
            v-if="selectedCount > 0"
            class="btn-success kr-unv-btn"
            @click="bulkAction"
            :process="process"
          >
            <i class="fa fa-eye" style="margin-right:8px"></i>{{ selectedCount }} rezervasyonu tekrar göster
          </Btn>
        </div>
        <dataTable
          :name="'unVisibleDataTable'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :rowHeight="30"
          :isSelectedRowCount="true"
          :data="gridData"
          @cellClicked="clickedCell"
          @cellDoubleClicked="onDbl"
          :addContextMenuItem="getContextMenuItems"
        ></dataTable>
      </div>
    </template>
  </modal>

  <reservationJsonModal
    v-if="detailShow != null"
    :reservation="detailShow"
    @close="detailShow = null"
    @deUnvisible="
      detailShow = null;
      deUnvisible([$event.Id]);
    "
  ></reservationJsonModal>
</template>

<script>
import moment from "moment";
import reservationJsonModal from "./reservationJsonModal.vue";
// Admin surumu: client modalindeki $root.developmentSet.token guard'i cikarildi
// (admin oturumu $appAxiosAdmin token'ini zaten tasiyor). Endpoint client
// referansiyla ayni: Reservation/DeUnvisible (backend prefix'i gerekirse guncelle).
export default {
  name: "unVisibleModal",
  components: { reservationJsonModal },
  emits: ["close", "refreshed"],
  props: {
    UnVisibleData: { type: Array, default: () => [] },
  },
  data() {
    return {
      detailShow: null,
      gridData: [],
      selects: [],
      selectAll: false,
      process: false,
      columnDefs: [
        {
          filter: false,
          field: "isSelected",
          headerName: "",
          width: 30,
          cellRenderer: this.$CheckCellRenderer,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "Voucher",
          field: "Voucher",
          filter: "agTextColumnFilter",
          sortable: true,
          cellClick: true,
          width: 130,
        },
        {
          headerName: "Sağlayıcı",
          field: "ProviderName",
          filter: true,
          sortable: true,
          cellClick: true,
          width: 110,
        },
        {
          headerName: "Acente",
          field: "ProviderAgency",
          filter: true,
          sortable: true,
          cellClick: true,
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Otel",
          field: "HotelName",
          filter: true,
          sortable: true,
          cellClick: true,
          flex: 1,
          minWidth: 120,
          cellRenderer: function(params) {
            if (params.data == undefined) return params.value;
            return params.data.HotelName == null
              ? params.data.ProviderHotel
              : params.data.HotelName;
          },
        },
        {
          headerName: "Giriş",
          field: "Checkin",
          filter: false,
          sortable: true,
          cellClick: true,
          width: 100,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "Çıkış",
          field: "Checkout",
          filter: false,
          sortable: true,
          cellClick: true,
          width: 100,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "Tekrar Gösterme Tarihi",
          field: "UnVisibleDate",
          filter: false,
          sortable: true,
          cellClick: true,
          width: 200,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
          },
        },
      ],
    };
  },
  watch: {
    UnVisibleData: {
      immediate: true,
      handler(val) {
        this.gridData = (val || []).map((x) => ({ ...x, isSelected: false }));
        this.selects = [];
        this.selectAll = false;
      },
    },
  },
  computed: {
    selectedCount() {
      return this.selects.length;
    },
  },
  methods: {
    onDbl(e) {
      // isSelected (checkbox) hucresi haric cift-tik -> Detay + JSON modali.
      if (e.colDef && e.colDef.field === "isSelected") return;
      this.detailShow = e.data;
    },
    clickedCell(event) {
      if (event.colDef.field !== "isSelected") return;
      const id = event.data.Id;
      const isNowSelected = this.selects.indexOf(id) === -1;
      if (isNowSelected) {
        this.selects.push(id);
      } else {
        this.selects = this.selects.filter((x) => x != id);
      }
      const item = this.gridData.find((x) => x.Id == id);
      if (item) {
        item.isSelected = isNowSelected;
        this.$refs.agGrid.changeRow("Id", { ...item });
      }
    },
    selectAllClick() {
      const api = this.$refs.agGrid && this.$refs.agGrid.gridApi;
      if (!api) return;
      // Sadece MEVCUT SAYFADAKI satirlar. getDisplayedRowCount() tum filtreli
      // satirlari ( or. 234) verir; pagination dilimi ile sinirla (or. 25).
      const total = api.getDisplayedRowCount();
      const pageSize = api.paginationGetPageSize
        ? api.paginationGetPageSize()
        : total;
      const currentPage = api.paginationGetCurrentPage
        ? api.paginationGetCurrentPage()
        : 0;
      const start = currentPage * pageSize;
      const end = Math.min(start + pageSize, total);
      const visibleIds = [];
      for (let i = start; i < end; i++) {
        const node = api.getDisplayedRowAtIndex(i);
        if (node && node.data) visibleIds.push(node.data.Id);
      }
      if (this.selectAll) {
        visibleIds.forEach((id) => {
          if (this.selects.indexOf(id) === -1) this.selects.push(id);
        });
      } else {
        const visibleSet = new Set(visibleIds);
        this.selects = this.selects.filter((x) => !visibleSet.has(x));
      }
      visibleIds.forEach((id) => {
        const item = this.gridData.find((x) => x.Id == id);
        if (item) {
          item.isSelected = this.selectAll;
          this.$refs.agGrid.changeRow("Id", { ...item });
        }
      });
    },
    bulkAction() {
      const ids = [...this.selects];
      if (ids.length == 0) return;
      this.$swal({
        icon: "question",
        title: "Soru",
        text:
          "" +
          ids.length +
          " rezervasyonun tekrar gösterme işlemi geri alınacak. Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((question) => {
        if (question.isConfirmed) {
          this.deUnvisible(ids);
        }
      });
    },
    getContextMenuItems(params) {
      let result = ["copy", "export"];
      result.push({
        name: "TEKRAR GÖSTERMEYİ GERİ AL",
        icon: "<i class='fas fa-eye'></i>",
        action: () => {
          const id = params.node.data.Id;
          this.$swal({
            icon: "question",
            title: "Soru",
            text:
              (params.node.data.FullAgencyName || "Rezervasyon") +
              " tekrar gösterme işlemi geri alınacak. Onaylıyor musunuz?",
            showCancelButton: true,
            confirmButtonText: "Evet",
            cancelButtonText: "Hayır",
          }).then((question) => {
            if (question.isConfirmed) {
              this.deUnvisible([id]);
            }
          });
        },
      });
      return result;
    },
    deUnvisible(ids) {
      this.process = true;
      this.$appAxiosAdmin
        .post("Reservation/DeUnvisible", ids)
        .then(() => {
          this.process = false;
          // Basari geri bildirimi + parent'a hangi id'ler geri gosterildi bilgisi
          // (parent grid'i tazelesin, aksi halde satirlar hala UnVisible gorunur).
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: ids.length + " rezervasyon tekrar gösterildi.",
            timer: 1800,
            showConfirmButton: false,
          });
          this.$emit("refreshed", ids);
          this.$emit("close");
        })
        .catch((err) => {
          this.process = false;
          console.error("Reservation/DeUnvisible basarisiz:", err);
          this.$isError(err);
        });
    },
  },
};
</script>

<style scoped>
.kr-unv-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  min-height: 42px;
}
.kr-selectall {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #23232a);
  white-space: nowrap;
  user-select: none;
}
/* Materialize native checkbox'lari global gizliyor (opacity:0/position:absolute);
   burada tek checkbox'i geri gorunur + native (teal) yapmak icin eziyoruz. */
.kr-selectall input[type="checkbox"] {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  -webkit-appearance: checkbox !important;
  -moz-appearance: checkbox !important;
  appearance: auto !important;
  width: 16px;
  height: 16px;
  accent-color: var(--color-brand-500, #1e88e5);
  cursor: pointer;
  margin: 0;
  flex: 0 0 auto;
}
/* Tekrar göster butonu: sabit flex ogesi + ferah padding + tek satir */
.kr-unv-btn {
  flex: 0 0 auto;
  padding: 9px 20px !important;
  font-size: 13px !important;
  line-height: 1.2 !important;
  white-space: nowrap;
  height: auto !important;
}
</style>
